import { gql } from '@apollo/client'

const COMPETITOR_ANALYSIS_QUERY = gql`
  query competitorAnalysis(
    $stationIds: [ID!]!
    $fuelGradeId: ID!
    $currentPeriodStartDate: String!
    $currentPeriodEndDate: String!
    $stationGroupNames: [String]
    $activeTab: String
    $metricName: String!
    $competitorStationGuids: [ID]
  ) {
    competitorAnalysis(
      input: {
        stationIds: $stationIds
        fuelGradeId: $fuelGradeId
        currentPeriodStartDate: $currentPeriodStartDate
        currentPeriodEndDate: $currentPeriodEndDate
        stationGroupNames: $stationGroupNames
        activeTab: $activeTab
        metricName: $metricName
        competitorStationGuids: $competitorStationGuids
      }
    ) {
      ownPolePrices {
        datetimes
        polePrices
        }
      comparisonMetric {
        name
        dates
        values
      }
      competitorPolePrices {
        competitor
        datetimes
        polePrices
      }
    }
  }
`

export { COMPETITOR_ANALYSIS_QUERY }
